export const showFundsCategories = (state) => state.fundsCategories
